import React, { Fragment } from 'react';
import { Grid, FormControlLabel, RadioGroup, Radio, FormLabel } from '@material-ui/core';
import { useStyle } from './style';
import { DIRECTORY_PREFERENCES } from './constants';

export const EirDirectoryPreferences = (props) => {
    const classes = useStyle();
    const { directoryPreference, setDirectoryPreference } = props;

    const handleChange = (event) => {
        setDirectoryPreference(event.target.value);
    };

    return (
        <Fragment>
            <h4 className={classes.margintop}>National Directory Preference</h4>
            <Grid container spacing={1}>
                <Grid item sm={12}>
                    <FormLabel className={classes.formLabelColor}> Would you like your phone number to be included in a directory?</FormLabel>
                </Grid>
                <Grid item sm={12}>
                    <RadioGroup name="directoryPreference" value={directoryPreference}
                        onChange={handleChange} >
                        <FormControlLabel value="EXDIRECTORY" className={classes.formLabelColor} control={<Radio color="primary" />} label={DIRECTORY_PREFERENCES.EXDIRECTORY} />
                        <FormControlLabel value="LISTED" className={classes.formLabelColor} control={<Radio color="primary" />} label={DIRECTORY_PREFERENCES.LISTED} />
                        <FormControlLabel value="UNLISTED" className={classes.formLabelColor} control={<Radio color="primary" />} label={DIRECTORY_PREFERENCES.UNLISTED} />
                    </RadioGroup>

                </Grid>
            </Grid>

        </Fragment>
    );
}